const prefix = <const T extends string>(id: T) => `CardBenefits.${id}` as const

export const CardBenefitsE2E = {
  Users: {
    /**
     * Highnote user: Highnote User
     * Used to test viewing benefits list and specific benefit details
     */
    Highnote: {
      Email: '221cf318-6fc3-4688-9b4a-48e156614ab0@mailslurp.biz',
      FirstName: 'End To End Testing',
      LastName: 'Card Statements General',
      PhoneNumber: '(562) 639-6898',
    },
    /**
     * Platform user: User who has a Lithic/LoanPro card.
     * Used to test the home screen card application call-to-action for platform users.
     */
    Platform: {
      Email: '53bdd1cd-80f3-473e-88c7-d58f15606b48@mailslurp.biz',
      FirstName: 'End To End Testing',
      LastName: 'Home Platform',
      PhoneNumber: '(892) 123-8915',
    },
  },
  Ids: {
    View: {
      BenefitsIndex: prefix('View.BenefitsIndex'),
      BenefitsTiles: prefix('View.BenefitsTiles'),
      BenefitScroll: prefix('View.BenefitScroll'),
    },
    Press: {
      Benefit: (partnerName: string) => `benefit-${partnerName}`,
    },
  },
} as const
